import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Spin, Tooltip } from 'antd';
import { useIntl } from 'react-intl';
import { HeartFilled, HeartTwoTone } from '@ant-design/icons';

import { RootState } from '@share/utils';
import { handleSavedProperties } from '@share/store/slices';
import { ISavedProperties } from '@share/common-types';

import './style.scss';

export enum SavePropertyTypes {
  Hotel = 'hotel',
  Condo = 'condo',
}

interface IProps {
  isSaved: boolean;

  id: number;
  title: string;
  thumb?: any;
  images: any[];
  starRating: number;
  reviewsCount: number;
  fullAddress: string;
  type: SavePropertyTypes;

  className?: string;
}

export function SaveProperty(props: IProps) {
  const { isSaved, type, fullAddress, thumb, images, id, title, starRating, reviewsCount, className } = props;
  const intl = useIntl();
  const dispatch = useDispatch();

  const { loading } = useSelector((state: RootState) => state.savedPropertiesStore);
  const { account } = useSelector((state: RootState) => state.loginStore);
  const { items } = useSelector((state: RootState) => state.navigationMenuStore);

  const [displayLoading, setDisplayLoading] = useState(false);

  const organizationId = items?.organizationId;
  const siteId = items?.siteId;
  
  const isRSITemplate = account?.isRSITemplate;
  const isPublicAccountType = account?.isPublicAccountType;
  const displaySavedProperties = account?.displaySavedProperties;
  const displaySavedPropertiesRsiSiteidList = account?.displaySavedPropertiesRsiSiteidList;
  const displaySavedPropertiesRsiOrgidList = account?.displaySavedPropertiesRsiOrgidList;
  
  const emptyOrgIdList = !!displaySavedPropertiesRsiOrgidList?.length;
  const emptySiteIdList = !!displaySavedPropertiesRsiSiteidList?.length;

  const isOrgId = displaySavedPropertiesRsiOrgidList?.includes(organizationId?.toString() as string);
  const isSiteId = displaySavedPropertiesRsiSiteidList?.includes(siteId?.toString() as string);
  
  const displayRsi = isRSITemplate && ((!emptyOrgIdList && !emptySiteIdList) || isOrgId || isSiteId)
  const displayRest = !isRSITemplate;

  if (isPublicAccountType || !(displaySavedProperties && (displayRsi || displayRest))) {
    return null;
  }

  useEffect(() => {
    if (!loading) {
      setDisplayLoading(false);
    }
  }, [loading]);

  const handleSavedProperty = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    const prop: ISavedProperties = {
      propertyId: id,
      imgSrc: thumb || images[0].url,
      name: title,
      address: fullAddress,
      rating: starRating,
      reviewsCount: reviewsCount,
      type
    }

    setDisplayLoading(true);

    dispatch(handleSavedProperties(prop));
  };
  
  const heartIcon = displayLoading
    ? <Spin />
    : isSaved
      ? <HeartFilled className="favorite-property-wrapper__heart favorite-property-wrapper__heart--saved" />
      : <HeartTwoTone twoToneColor="#f40b0b" className="favorite-property-wrapper__heart favorite-property-wrapper__heart--unsaved" />;

  return (
    <div className={`favorite-property-wrapper ${className ? className : ''}`}>
      <Tooltip title={intl.formatMessage({ id: isSaved ? 'saved.property' : 'save.property' })}>
        <Button onClick={e => handleSavedProperty(e)} shape="circle" icon={heartIcon} />
      </Tooltip>
    </div>
  );
}
